/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Rehab_BodyInputs */

const en_for_whom_rehab_body = /** @type {(inputs: For_Whom_Rehab_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your physio writes the exercises, you do them at home between visits and log the sets in the app. At the next visit you both see how it went.`)
};

const pl_for_whom_rehab_body = /** @type {(inputs: For_Whom_Rehab_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizjoterapeuta rozpisuje ćwiczenia, a Ty robisz je w domu między wizytami i zaliczasz serie w aplikacji. Na kolejnej wizycie oboje widzicie, jak poszło.`)
};

/**
* | output |
* | --- |
* | "Your physio writes the exercises, you do them at home between visits and log the sets in the app. At the next visit you both see how it went." |
*
* @param {For_Whom_Rehab_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_rehab_body = /** @type {((inputs?: For_Whom_Rehab_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Rehab_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_rehab_body(inputs)
	return en_for_whom_rehab_body(inputs)
});